import { render, staticRenderFns } from "./merchant-order.vue?vue&type=template&id=21260908&scoped=true"
import script from "./merchant-order.vue?vue&type=script&lang=js"
export * from "./merchant-order.vue?vue&type=script&lang=js"
import style0 from "./merchant-order.vue?vue&type=style&index=0&id=21260908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21260908",
  null
  
)

export default component.exports